import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Auth } from '@jg/auth';
import { Action } from 'redux';
import { ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { generateAuthHeaders, redirectByResponseStatus } from '../../utils';
import { IAppState } from '../../types/state.d';
import {
  teamRequestMade,
  teamRequestSuccess,
  teamRequestError,
} from '../actionCreators/apiActions';

const fetchTeamData = (teamGuid: string) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  _state: () => IAppState,
  auth: Auth,
) => {
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(teamRequestMade());
    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/full`,
      {
        extraHeaders: generateAuthHeaders(auth),
      },
    );

    if (response && !response.ok) {
      redirectByResponseStatus(response.status);
      throw new Error(response.status.toString());
    }
    const data = await response.json();
    dispatch(
      teamRequestSuccess({
        ...data,
        teamGuid,
      }),
    );
  } catch (error) {
    if (error.message === '404' || error.message === '400') {
      dispatch(teamRequestError(error.message));
    } else {
      dispatch(teamRequestError(ERROR_MESSAGES.GET_PAGE_DATA));
    }
    throw error;
  }
};

export default fetchTeamData;
